// extracted by mini-css-extract-plugin
export default {"center":"Center__center__V2Mzq"};